import { render, staticRenderFns } from "./ShippingLogBLDetailBLElPop.vue?vue&type=template&id=c7877846"
import script from "./ShippingLogBLDetailBLElPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailBLElPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7877846')) {
      api.createRecord('c7877846', component.options)
    } else {
      api.reload('c7877846', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailBLElPop.vue?vue&type=template&id=c7877846", function () {
      api.rerender('c7877846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailBLElPop.vue"
export default component.exports